import { ActorProfilePreviewFragmentFragment, UserQuery } from '@lopo-tech/lopo-api'
import { ProfileType } from 'src/interfaces/profile'
import { getConfigValue } from 'src/utils/config/config'

export const getMessengerToggle = (type: ProfileType) =>
  isMessengerFlagEnabled() && type === 'PrivateProfile'
export const isMessengerFlagEnabled = () => getConfigValue<boolean>('plugins.messengerToggle.enabled')

export const isUserMessagable = (profile?: UserQuery['currentProfile'] | ActorProfilePreviewFragmentFragment) => {
  if (!profile) return false

  if (profile.__typename === 'PrivateProfile') {
    return profile.canMessage?.value
  }

  return true
}
